import React from 'react'
import { connect } from 'react-redux'
import { Body } from 'components/Shell/Shell'
// import ls from 'local-storage'
import { toggleSidebarCollapse, overrideSidebarResizing } from '../../actions'
// import FloatingMenu from 'components/FloatingMenu/FloatingMenu'
// import DotMenuIcon from "@tecuity/sos-icons/react/dot-menu"
// import { GET_DASHBOARD_DATA } from 'requests'
// import { colors as mixColors } from 'just-mix'
import './Dashboard.scss'

let Dashboard = {}

class DeferredDashboard extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      fetchingBundle: true
    }
  }
  componentDidMount = () => {
    this.fetchBundle()
    // this.props.overrideSidebarResizing(true)
    // this.props.toggleSidebarCollapse(true)
  }
  componentWillUnmount = () => {
    // if (document.body.clientWidth > 800) this.props.overrideSidebarResizing(false);
    // this.props.toggleSidebarCollapse(false)
  }
  fetchBundle = () => {
    require.ensure(
      ['./Dashboard'],
      require => {
        Dashboard = require('./Dashboard').default
        this.setState({ fetchingBundle: false })
      },
      './Dashboard'
    )
  }
  render() {
    const { username } = this.props
    return (
      <Body className="dashboard-wrapper full-height-page">
        {
          !this.state.fetchingBundle &&
          <Dashboard username={username}  />
        }
      </Body>
    )
  }
}
export default connect(
  state => {
    const username = state.auth.FIRST_NAME || state.auth.USERNAME
    return { username }
  },
  {
    toggleSidebarCollapse,
    overrideSidebarResizing
  }
)(DeferredDashboard)



// WEBPACK FOOTER //
// ./src/components/Dashboard/DeferredDashboard.js